// extracted by mini-css-extract-plugin
module.exports = {"description":"AllUnclaimBusiness_description__1JUwW"};